module.exports = __webpack_public_path__ + "static/impacto-1371e83b9f3bff4a713f284e3d98492e.png";